import React from 'react';
import { Button } from '../ui/button';

/** One full-width "Sign in with …" button, for a provider or Email. */
const SignInMethodButton = ({ method, verb = 'Sign in with', busyLabel, busy = false, disabled = false, onClick }) => {
  const { Icon, label } = method;
  return (
    <Button
      onClick={onClick}
      className="w-full h-12 text-base font-normal"
      variant="outline"
      disabled={disabled || busy}
    >
      <Icon className="h-5 w-5 mr-3" />
      {busy && busyLabel ? busyLabel : `${verb} ${label}`}
    </Button>
  );
};

export default SignInMethodButton;
